// Header/footer content of jobnet.works (sid wrktp), mirrored from the main site.
// The main site exists only in English and German and uses different slugs per language,
// so every other portal language falls back to English.

export type WrktpLang = 'en' | 'de';

export interface WrktpLink {
  text: string
  path: string
}

interface WrktpContent {
  nav: {
    welcome: WrktpLink
    recruitment: WrktpLink
    jobPlacement: WrktpLink
    avgsMpav: WrktpLink
    itOutstaffing: WrktpLink
    aboutUs: WrktpLink
    contact: WrktpLink
  }
  privacy: WrktpLink
  imprint: string
  mainNavLabel: string
  toggleNavLabel: string
  pagesHeading: string
  servicesHeading: string
  companyHeading: string
  legalLabel: string
  description: string
  registeredOffice: string
  hotlineGermany: string
  hotlineAustria: string
  company: {
    company: string
    office: string
    azav: string
    azavValue: string
    certBody: string
    hotlineDe: string
    hotlineAt: string
  }
  copyright: string
}

export const wrktpContent: Record<WrktpLang, WrktpContent> = {
  en: {
    nav: {
      welcome: { text: 'Welcome', path: '' },
      recruitment: { text: 'Recruitment', path: 'recruitment' },
      jobPlacement: { text: 'Job Placement', path: 'job-placement' },
      avgsMpav: { text: 'AVGS MPAV', path: 'job-placement/avgs-mpav' },
      itOutstaffing: { text: 'IT Outstaffing', path: 'it-outstaffing' },
      aboutUs: { text: 'About Us', path: 'about-us' },
      contact: { text: 'Contact', path: 'contact' },
    },
    privacy: { text: 'Privacy policy', path: 'privacy-policy' },
    imprint: 'Imprint',
    mainNavLabel: 'Main navigation',
    toggleNavLabel: 'Toggle navigation',
    pagesHeading: 'Pages',
    servicesHeading: 'Services',
    companyHeading: 'Company information',
    legalLabel: 'Legal',
    description: 'Job placement, recruitment, IT outstaffing, and digital collaboration on one shared platform — '
      + 'for more and better employment.',
    registeredOffice: 'Registered office',
    hotlineGermany: 'Germany',
    hotlineAustria: 'Austria',
    company: {
      company: 'Company',
      office: 'Registered office',
      azav: 'AZAV certificate',
      azavValue: 'Nr. TZ-104194 (valid until 9 August 2031)',
      certBody: 'Certification body',
      hotlineDe: 'Hotline Germany',
      hotlineAt: 'Hotline Austria',
    },
    copyright: 'AZAV-Zertifikats-Nr. TZ-104194, gültig bis 09.08.2031 (Certuria Certification Germany GmbH)',
  },
  de: {
    nav: {
      welcome: { text: 'Willkommen', path: 'willkommen' },
      recruitment: { text: 'Personalvermittlung', path: 'personalvermittlung' },
      jobPlacement: { text: 'Arbeitsvermittlung', path: 'arbeitsvermittlung' },
      avgsMpav: { text: 'AVGS MPAV', path: 'arbeitsvermittlung/avgs-mpav' },
      itOutstaffing: { text: 'IT-Outstaffing', path: 'it-outstaffing' },
      aboutUs: { text: 'Über uns', path: 'ueber-uns' },
      contact: { text: 'Kontakt', path: 'kontakt' },
    },
    privacy: { text: 'Datenschutz', path: 'node/3' },
    imprint: 'Impressum',
    mainNavLabel: 'Hauptnavigation',
    toggleNavLabel: 'Navigation umschalten',
    pagesHeading: 'Seiten',
    servicesHeading: 'Leistungen',
    companyHeading: 'Unternehmensangaben',
    legalLabel: 'Rechtliches',
    description: 'Arbeitsvermittlung, Personalvermittlung, IT-Outstaffing und digitale Zusammenarbeit '
      + 'auf einer gemeinsamen Plattform — für mehr und gute Beschäftigung.',
    registeredOffice: 'Sitz der Gesellschaft',
    hotlineGermany: 'Deutschland',
    hotlineAustria: 'Österreich',
    company: {
      company: 'Unternehmen',
      office: 'Sitz',
      azav: 'AZAV-Zertifikat',
      azavValue: 'Nr. TZ-104194 (gültig bis 09.08.2031)',
      certBody: 'Zertifizierungsstelle',
      hotlineDe: 'Hotline DE',
      hotlineAt: 'Hotline AT',
    },
    copyright: 'AZAV-Zertifikats-Nr. TZ-104194, gültig bis 09.08.2031 (Certuria Certification Germany GmbH)',
  },
};

export const WRKTP_IMPRINT_URL = 'https://jobnet.ag/JobnetAG/Kontakt/impressum.php';

export const wrktpLang = (lang: string): WrktpLang => (lang === 'de' ? 'de' : 'en');

// Header and footer link to the new jobnet.works site exactly as its own header/footer do
export const WRKTP_SITE_URL = 'https://jobnetworks.subr-dev.pp.ua';

export const wrktpTalentSpaceUrl = (lang: WrktpLang): string => `https://talentspace.jobnet.works/?lang=${lang}`;

export const wrktpUrl = (lang: WrktpLang, path: string): string => {
  const base = `${WRKTP_SITE_URL}/${lang}`;
  return path ? `${base}/${path}` : base;
};
